import React, { Component, useEffect } from 'react';
import './Splash.css';
import { useNavigate } from 'react-router-dom';
import { white ,pink} from '../../constants';
import logo from '../../images/logoslogan.png'
import { ProgressBar } from '../../components/ProgressBar/ProgressBar'

import Spinner from 'react-bootstrap/Spinner';



export default function Splash() {
  let navigate = useNavigate();

  return (
    <div>
      <div className='root'>

        <div className='splash_bg'>

          <div style={{ width: '25vw', height: '100vh', backgroundColor: white }}></div>
          <div style={{ width: '25vw', height: '100vh', backgroundColor: white }}></div>
          <div style={{ width: '25vw', height: '100vh', backgroundColor: white }}></div>
          <div style={{ width: '25vw', height: '100vh', backgroundColor: white }}></div>

        </div>


        <div className='splash_logo' style={{ color: "white" }}>
          <img src={logo} alt='forest' width="200px" height="180px" />
          <Spinner animation="border" role="status" style={{color:pink,marginTop:"30px"}}>
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          {setTimeout(() => { navigate('/home', { replace: true }); }, 3000)}
        </div>


      </div>
    </div>
  )

}


